'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@/utils/constants';

type FooterRouteGateProps = {
    children: ReactNode;
};

export const FooterRouteGate = ({ children }: FooterRouteGateProps) => {
    const pathname = usePathname() ?? '/';

    if (pathname.startsWith(ROUTES.GAMEPLAY_SESSION) || pathname.startsWith(ROUTES.CHALLENGE_DETAILS)) {
        return null;
    }

    return <>{children}</>;
};
